
import {
  S3Client,
  PutObjectCommand,
} from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage'
import axios from "axios";
import config from '../config.js';

export async function getCesiumS3Bucket(_name, _description, _cesium_token, _sourceType = 'POINT_CLOUD', _coordinates = null)
{
    const options = {
        sourceType: _sourceType,
        //clampToTerrain: true,
        //baseTerrainId: 1
    };

    // Add position array if coordinates are provided
    if (_coordinates && _coordinates.length === 3) {
        options.position = [
            parseFloat(_coordinates[0]), // longitude
            parseFloat(_coordinates[1]), // latitude
            parseFloat(_coordinates[2])  // height
        ];
    }

    let _type='3DTILES'
    if(_sourceType=="GEOJSON")
    {
      _type="GEOJSON";
    }

    const postBody ={
        name: _name,
        description: _description,
        type: _type,
        options: options
    }
    const createRes = await fetch(`${config.cesiumUploadUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${_cesium_token}`,
        },
        body: JSON.stringify(postBody), 
      });

      console.log(createRes)
      return await createRes.json();
}

async function getCesiumS3BucketForPhotos(_name, _cesium_token)
{
    const outputs = [
      //{ outputType: '3DTILES' },
      { outputType: 'SPLATS_3DTILES',
        options:{
          referenceQuality:'High'
        }
      }                                                                                                                                 
    ];

    const options = {
        sourceType: 'RASTER_IMAGERY',
        //meshQuality:'Medium',
        useGpsInfo:true,
        outputs:outputs
    };

    const postBody ={
        name: _name,
        description:'GS reconstruction',
        type: '3DTILES',
        options: options
    }
    const createRes = await fetch(`${config.cesiumUploadUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${_cesium_token}`,
        },
        body: JSON.stringify(postBody), 
      });

      console.log(createRes)
      return await createRes.json();
}

async function setupS3Client(_name, _description, _cesium_token, _sourceType = 'POINT_CLOUD', _coordinates = null)
{
    const response = await getCesiumS3Bucket(_name, _description, _cesium_token, _sourceType, _coordinates);

    console.log(response)

    const bucketProps = {
        region: 'us-east-1',
        endpoint: response.uploadLocation.endpoint,
        credentials: {
            accessKeyId: response.uploadLocation.accessKey,
            secretAccessKey: response.uploadLocation.secretAccessKey,
            sessionToken: response.uploadLocation.sessionToken
        },
        requestChecksumCalculation: "WHEN_REQUIRED",
    } 

    const s3client = new S3Client(bucketProps);

    s3client.middlewareStack.add(
        (next) =>
          async (args) => {
            const request = args.request;
  
            // Remove checksum headers
            const headers = request.headers;
            delete headers["x-amz-checksum-crc32"];
            delete headers["x-amz-checksum-crc32c"];
            delete headers["x-amz-checksum-sha1"];
            delete headers["x-amz-checksum-sha256"];
            request.headers = headers;
  
            Object.entries(request.headers).forEach(
              // @ts-ignore
              ([key, value]) => {
                if (!request.headers) {
                  request.headers = {};
                }
                (request.headers)[key] = value;
              }
            );
  
            return next(args);
          },
        { step: "build", name: "customHeaders" }
      );

      console.log(response)
    return {client:s3client,prefix:response.uploadLocation.prefix,bucket:response.uploadLocation.bucket, onComplete:response.onComplete, id:response.assetMetadata.id};
}

async function setupS3ClientForPhotos(_name, _cesium_token)
{
    const response = await getCesiumS3BucketForPhotos(_name, _cesium_token);

    console.log(response);

    const bucketProps = {
        region: 'us-east-1',
        endpoint: response.uploadLocation.endpoint,
        credentials: {
            accessKeyId: response.uploadLocation.accessKey,
            secretAccessKey: response.uploadLocation.secretAccessKey,
            sessionToken: response.uploadLocation.sessionToken
        },
        requestChecksumCalculation: "WHEN_REQUIRED",
    } 

    const s3client = new S3Client(bucketProps);

    s3client.middlewareStack.add(
        (next) =>
          async (args) => {
            const request = args.request;
  
            // Remove checksum headers
            const headers = request.headers;
            delete headers["x-amz-checksum-crc32"];
            delete headers["x-amz-checksum-crc32c"];
            delete headers["x-amz-checksum-sha1"];
            delete headers["x-amz-checksum-sha256"];
            request.headers = headers;
  
            Object.entries(request.headers).forEach(
              // @ts-ignore
              ([key, value]) => {
                if (!request.headers) {
                  request.headers = {};
                }
                (request.headers)[key] = value;
              }
            );
  
            return next(args);
          },
        { step: "build", name: "customHeaders" }
      );

      console.log(response)
    return {client:s3client,prefix:response.uploadLocation.prefix,bucket:response.uploadLocation.bucket, onComplete:response.onComplete, id:response.assets[0].id};
}

export async function uploadToCesiumS3(_name, _description, body, _cesium_token, setProgress, _sourceType = 'POINT_CLOUD', _coordinates = null) {
  let {client,prefix,bucket,onComplete,id} = await setupS3Client(_name, _description, _cesium_token, _sourceType, _coordinates);

  let k = `${prefix}` + _name;

  try {
    const upload = new Upload({
      client: client,
      params: {
        Bucket: bucket,
        Key: k,
        Body: body,
      },
    });

    upload.on("httpUploadProgress", progress => {
      let currentProgress = parseFloat(progress.loaded) / parseFloat(progress.total);
      setProgress(Math.round(currentProgress * 100));
    });

    const result = await upload.done();
    console.log("Upload completed successfully. Result:", result);

    const onCompleteRes = await fetch(`${onComplete.url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${_cesium_token}`,
        },
        body: JSON.stringify(onComplete.fields), 
      });
    console.log(onCompleteRes);

    //we return the Cesium id of the file
    return id;

  } catch (err) {
    console.error(err);
  }
};

export async function uploadObjBundleToCesiumS3(
  _name,
  _description,
  objFile,
  materialFiles,
  _cesium_token,
  setProgress,
  _coordinates = null
) {
  let {client,prefix,bucket,onComplete,id} = await setupS3Client(_name, _description, _cesium_token, '3D_MODEL', _coordinates);

  const files = [objFile, ...(Array.isArray(materialFiles) ? materialFiles : [])].filter(Boolean);
  if (files.length === 0) {
    return id;
  }

  const fileEntries = files.map((file, index) => ({
    file,
    key: `${prefix}${file.name}`,
    progressKey: `${file.name}-${file.lastModified ?? index}`,
    size: file.size || 0,
  }));

  const totalBytes = fileEntries.reduce((sum, entry) => sum + entry.size, 0);
  const progressMap = new Map(
    fileEntries.map((entry) => [entry.progressKey, { loaded: 0, total: entry.size }])
  );
  let completedCount = 0;

  const updateProgress = () => {
    if (typeof setProgress !== 'function') {
      return;
    }
    if (totalBytes > 0) {
      const loadedBytes = Array.from(progressMap.values()).reduce(
        (sum, value) => sum + (value.loaded || 0),
        0
      );
      setProgress(Math.round((loadedBytes / totalBytes) * 100));
      return;
    }
    const percent = Math.round((completedCount / fileEntries.length) * 100);
    setProgress(percent);
  };

  const uploadSingleFile = async (entry) => {
    const upload = new Upload({
      client,
      params: {
        Bucket: bucket,
        Key: entry.key,
        Body: entry.file,
      },
    });

    upload.on("httpUploadProgress", (progress) => {
      if (!progress || typeof progress.loaded !== 'number') {
        return;
      }
      const total = progress.total || entry.size || 0;
      progressMap.set(entry.progressKey, { loaded: progress.loaded, total });
      updateProgress();
    });

    await upload.done();
    completedCount += 1;
    progressMap.set(entry.progressKey, { loaded: entry.size || 0, total: entry.size || 0 });
    updateProgress();
  };

  try {
    updateProgress();
    await Promise.all(fileEntries.map((entry) => uploadSingleFile(entry)));

    const onCompleteRes = await fetch(`${onComplete.url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${_cesium_token}`,
      },
      body: JSON.stringify(onComplete.fields),
    });
    console.log(onCompleteRes);
    if (typeof setProgress === 'function') {
      setProgress(100);
    }

    return id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function uploadPhotosToCesiumS3(_name, photos, _cesium_token, setProgress) {

  let {client,prefix,bucket,onComplete,id} = await setupS3ClientForPhotos(_name, _cesium_token);

  const totalPhotos = photos.length;
  if (totalPhotos === 0) {
    return id;
  }

  let completed = 0;

  const uploadSinglePhoto = async (photoFile, index) => {
    const key = `${prefix}${photoFile.name}`;

    const upload = new Upload({
      client,
      params: {
        Bucket: bucket,
        Key: key,
        Body: photoFile,
      },
    });

    upload.on("httpUploadProgress", (progress) => {
      if (progress.total && progress.loaded) {
        const currentPhotoProgress = progress.loaded / progress.total;
        const aggregateProgress =
          ((completed + currentPhotoProgress) / totalPhotos) * 100;
        setProgress(Math.round(aggregateProgress));
      }
    });

    await upload.done();
    completed += 1;
    setProgress(Math.round((completed / totalPhotos) * 100));
  };

  try {
    for (let i = 0; i < photos.length; i += 1) {
      await uploadSinglePhoto(photos[i], i);
    }

    const onCompleteRes = await fetch(`${onComplete.url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${_cesium_token}`,
      },
      body: JSON.stringify(onComplete.fields),
    });
    console.log(onCompleteRes);

    return id;
  } catch (error) {
    console.error(error);
    throw error;
  }

}

export async function deleteFromCesiumIon(_assetID,_cesium_token)
{
      const createRes = await fetch(`${config.cesiumUploadUrl}/${_assetID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${_cesium_token}`,
        }
      });
      
      // Check if response has content before trying to parse JSON
      const text = await createRes.text();
      if (text && text.trim()) {
        return JSON.parse(text);
      }
      
      // Return success status if no content
      return { success: createRes.ok, status: createRes.status };
}

export async function deleteUserDataFromCesiumIon(user,_cesium_token)
{
  if (!user || !Array.isArray(user.projects)) {
    return [];
  }

  const deletions = [];

  user.projects.forEach((project) => {
    if (project?.service !== 'mapping' || !Array.isArray(project.data)) {
      return;
    }

    project.data.forEach((entry) => {
      const assetId = entry?.id_cesium;
      if (!assetId) {
        return;
      }

      deletions.push({
        assetId,
        promise: deleteFromCesiumIon(assetId, _cesium_token),
      });
    });
  });

  if (!deletions.length) {
    return [];
  }

  const settled = await Promise.allSettled(deletions.map(({ promise }) => promise));

  return settled.map((result, index) => {
    const { assetId } = deletions[index];

    if (result.status === 'fulfilled') {
      return { assetId, status: 'fulfilled', data: result.value };
    }

    console.error(`Failed to delete Cesium asset ${assetId}`, result.reason);
    return { assetId, status: 'rejected', reason: result.reason };
  });
}

export async function getCesiumAssetMetadata(_assetID, _cesium_token)
{
      const createRes = await fetch(`${config.cesiumUploadUrl}/${_assetID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${_cesium_token}`,
        }
      });
      
      if (createRes.ok) {
        return await createRes.json();
      } else {
        throw new Error(`Failed to fetch asset metadata: ${createRes.status} ${createRes.statusText}`);
      }
}

